import React from "react";

const FolderDetailsTable = ({
  foldersData,
  detailsFolder,
  downloadFileDirectly,
  toggleSelectFileAll,
  selectedFiles,
  toggleFileSelection,
  folderDetailsModal,
  addFolderFavorite,
}) => {
  return (
    <div className="shared_folder_body">
      <table>
        <thead>
          <tr>
            {foldersData.length > 0 && (
              <th>
                <label className="cl-checkbox">
                  <input
                    type="checkbox"
                    onChange={toggleSelectFileAll}
                    checked={
                      selectedFiles.length === foldersData.length &&
                      foldersData.length > 0
                    }
                  />
                  <span></span>
                </label>
              </th>
            )}
            <th>Name</th>
            <th>Uploaded</th>
            <th>Details</th>
          </tr>
        </thead>
        <tbody>
          {foldersData.length > 0 ? (
            foldersData.map((folder) => (
              <tr key={folder.entity_id}>
                <td>
                  <label className="cl-checkbox">
                    <input
                      type="checkbox"
                      checked={selectedFiles.includes(folder.entity_id)} // ✅ Only select this row if it's in selectedUsers
                      onChange={() => toggleFileSelection(folder.entity_id)}
                    />
                    <span></span>
                  </label>
                </td>
                <td>
                  <div className="floder_dtls">
                    {folder.file_type !== "" ? (
                      ""
                    ) : (
                      <span
                        className="star"
                        type="button"
                        onClick={() =>
                          addFolderFavorite(
                            folder.entity_id,
                            folder.is_favorite
                          )
                        }
                      >
                        <i
                          className={
                            folder.is_favorite === true
                              ? "fa-solid fa-star"
                              : "fa-regular fa-star"
                          }
                        ></i>
                      </span>
                    )}

                    <div className="floder_dtls_inner">
                      <div
                        className="folder-clickable floder_dtls_inner"
                        onClick={() =>
                          detailsFolder(
                            folder.entity_id,
                            folder.file_type,
                            folder.entity_location
                          )
                        }
                        style={{
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <span>
                          {folder.file_type !== "" ? (
                            <i className="fa-regular fa-file-pdf"></i>
                          ) : (
                            <i className="fa-solid fa-folder-open"></i>
                          )}
                        </span>

                        <p> {folder.entity_name}</p>
                      </div>
                      {folder.file_type !== "" ? (
                        ""
                      ) : (
                        <em
                          type="button"
                          onClick={() => folderDetailsModal(folder.entity_id)}
                        >
                          <i className="fa-solid fa-circle-info"></i>
                        </em>
                      )}
                    </div>
                  </div>
                </td>
                <td>
                  {folder.entity_created
                    ? new Date(folder.entity_created)
                        .toLocaleString("en-GB", {
                          year: "numeric",
                          month: "2-digit",
                          day: "2-digit",
                          hour: "2-digit",
                          minute: "2-digit",
                          second: "2-digit",
                          hour12: false,
                        })
                        .replace(",", "") // ✅ Removes comma from date-time
                    : "N/A"}
                </td>

                <td>
                  <div className="share_dtls_btn_holder">
                    {folder.file_type !== "" ? (
                      <>
                        <button
                          type="button"
                          className="btn btn-outline-secondary"
                          onClick={() =>
                            detailsFolder(
                              folder.entity_id,
                              folder.file_type,
                              folder.entity_location
                            )
                          }
                        >
                          <span>
                            <i className="fa-solid fa-eye"></i>
                          </span>{" "}
                          Show
                        </button>
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={() => downloadFileDirectly(folder.entity_location)}
                          style={{ marginLeft: "8px" }}
                        >
                          <span>
                            <i className="fa-solid fa-download"></i>
                          </span>{" "}
                          Download
                        </button>
                      </>
                    ) : (
                      <>
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={() =>
                            detailsFolder(
                              folder.entity_id,
                              folder.file_type,
                              folder.entity_location
                            )
                          }
                        >
                          <span>
                            <i className="fa-solid fa-eye"></i>{" "}
                          </span>
                          Details
                        </button>
                      </>
                    )}
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="3" style={{ textAlign: "center", padding: "20px" }}>
                No Folders Found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default FolderDetailsTable;
